import { toInterceptor } from 'nike-re-framejs';
import { extractMiddlewareCtx } from './utils';

export const REFRAME_EVENTS_STACK = [];

REFRAME_EVENTS_STACK.push = function() {
    if (this.length >= 15) {
        this.shift();
    }
    return Array.prototype.push.apply(this, arguments);
};

export const pushReframeEventToStack = (eventName, eventArgs = []) => {
    let args: any[] | string;
    try {
        if (typeof eventArgs === 'string') {
            args = eventArgs;
        } else {
            args = Array.isArray(eventArgs) ? (eventArgs || []).filter(a => typeof a === 'string') : '';
        }
    } catch (e) {}

    REFRAME_EVENTS_STACK.push({
        name: eventName,
        args: args,
        timestamp: new Date()
    });
};

export const stackMiddleware = () =>
    toInterceptor({
        id: 'STACK_MIDDLEWARE',
        before: ctx => {
            const { eventName, eventArgs } = extractMiddlewareCtx(ctx);
            eventName && pushReframeEventToStack(eventName, eventArgs);
            return ctx;
        }
    });
